import React, { useState, useEffect, useMemo } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { getSignedUrlApi } from 'src/api/s3Upload';
import { useTranslation } from 'react-i18next';

type ReadSignedRequirements = {
  url: string;
  renderingCb: (url: string) => any;
};

export const ReadWithSignedUrl = (props: ReadSignedRequirements) => {
  const { url, renderingCb } = props;
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [signedUrl, setSignedUrl] = useState<string>();

  const fetchAndRenderSignedUrl = async () => {
    const response = await getSignedUrlApi(url);
    setIsLoading(false);
    const respSignedUrl: string = response?.data?.signedUrl ?? '';

    if (!response.isSuccess) {
      setErrorMessage(response.errorMessage);
      return;
    }
    if (!respSignedUrl) {
      setErrorMessage(t('Unable to retrieve signed Url'));
      return;
    }
    setSignedUrl(respSignedUrl);
  };

  useEffect(() => {
    fetchAndRenderSignedUrl();
  }, []);

  if (isLoading) {
    return <LoadingOutlined />;
  }
  if (errorMessage) {
    return <span>{errorMessage}</span>;
  }
  return signedUrl ? renderingCb(signedUrl) : null;
};
